import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MapContainer, TileLayer, CircleMarker, Popup, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import api from '../services/api';

const STATUS_KLEUR = {
  nieuw: '#ef4444',
  toegewezen: '#f59e0b',
  in_behandeling: '#3b82f6',
  afgerond: '#10b981'
};
const kleur = (s) => STATUS_KLEUR[s] || '#6b7280';

function weekRange(d) {
  const dt = new Date(d);
  const dag = (dt.getDay() + 6) % 7; // 0 = maandag
  const ma = new Date(dt); ma.setDate(dt.getDate() - dag);
  const zo = new Date(ma); zo.setDate(ma.getDate() + 6);
  const f = (x) => x.getFullYear() + '-' +
    String(x.getMonth() + 1).padStart(2, '0') + '-' +
    String(x.getDate()).padStart(2, '0');
  return [f(ma), f(zo)];
}

function FitBounds({ punten }) {
  const map = useMap();
  useEffect(() => {
    const t = setTimeout(() => map.invalidateSize(), 150);
    return () => clearTimeout(t);
  }, [map]);
  useEffect(() => {
    if (punten.length > 0) {
      map.fitBounds(punten.map((p) => [Number(p.lat), Number(p.lng)]),
        { padding: [40, 40], maxZoom: 15 });
    }
  }, [punten, map]);
  return null;
}

export default function PlanningKaart({ week }) {
  const [data, setData] = useState(null);
  const navigate = useNavigate();
  const [start, eind] = weekRange(week || new Date());

  useEffect(() => {
    let actief = true;
    setData(null);
    api.get('/planning/kaart', { params: { start_datum: start, eind_datum: eind } })
      .then((r) => { if (actief) setData(r.data); })
      .catch(() => { if (actief) setData({ totaal: 0, met_locatie: 0, punten: [], fout: true }); });
    return () => { actief = false; };
  }, [start, eind]);

  if (!data) {
    return <div style={{ padding: 16, color: '#64748b' }}>Kaart laden...</div>;
  }

  const zonder = data.totaal - data.met_locatie;

  return (
    <div style={{ marginBottom: 16, border: '1px solid #e2e8f0', borderRadius: 12, overflow: 'hidden', background: '#fff' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '8px 14px', flexWrap: 'wrap', fontSize: 13 }}>
        <strong>{'\u{1F5FA}\uFE0F'} Week {start} t/m {eind}</strong>
        <span style={{ color: '#64748b' }}>
          {data.met_locatie} van {data.totaal} geplande orders op de kaart
          {zonder > 0 ? ' \u00b7 ' + zonder + ' zonder locatie' : ''}
        </span>
        <span style={{ marginLeft: 'auto', display: 'flex', gap: 10, flexWrap: 'wrap' }}>
          {Object.entries(STATUS_KLEUR).map(([s, c]) => (
            <span key={s} style={{ display: 'inline-flex', alignItems: 'center', gap: 4, color: '#475569' }}>
              <span style={{ width: 10, height: 10, borderRadius: '50%', background: c, display: 'inline-block' }} />
              {s.replace('_', ' ')}
            </span>
          ))}
        </span>
      </div>
      <div style={{ height: 420 }}>
        <MapContainer center={[52.37, 4.89]} zoom={11} style={{ height: '100%', width: '100%' }}>
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; OpenStreetMap'
          />
          <FitBounds punten={data.punten} />
          {data.punten.map((p, i) => (
            <CircleMarker
              key={p.id + '-' + p.geplande_datum + '-' + i}
              center={[Number(p.lat), Number(p.lng)]}
              radius={10}
              pathOptions={{ color: '#fff', weight: 2, fillColor: kleur(p.status), fillOpacity: 0.9 }}
            >
              <Popup>
                <div style={{ minWidth: 180 }}>
                  <strong>{p.titel || (p.ordernummer ? '#' + p.ordernummer : 'Werkorder ' + p.id)}</strong>
                  {p.object_naam ? <div>{'\u{1F4CD}'} {p.object_naam}</div> : null}
                  <div>{'\u{1F4C5}'} {String(p.geplande_datum).slice(0, 10)}</div>
                  {p.monteurs ? <div>{'\u{1F477}'} {p.monteurs}</div> : null}
                  <div style={{ color: kleur(p.status), fontWeight: 600 }}>{p.status}</div>
                  <button
                    onClick={() => navigate('/werkorder/' + p.id)}
                    style={{ marginTop: 6, padding: '4px 10px', border: 'none', borderRadius: 6,
                             background: '#0ea5e9', color: '#fff', cursor: 'pointer' }}
                  >
                    Openen
                  </button>
                </div>
              </Popup>
            </CircleMarker>
          ))}
        </MapContainer>
      </div>
    </div>
  );
}
